import React from 'react'
import styled from 'styled-components'
import type { TFunction } from 'i18next'
import { Icon } from '../../../atoms/Icon'
import { RegBLLink } from './RegBLLink'

interface DataSourceBannerProps {
  egid?: number
  t: TFunction
  className?: string
}

const Banner = styled.div`
  padding: 16px 20px;
  background: linear-gradient(135deg, #3b82f615 0%, #3b82f608 100%);
  border: 1px solid #3b82f630;
  border-radius: ${({ theme }) => theme.borderRadius.default};
  margin-bottom: 24px;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: #3b82f6;
  font-size: ${({ theme }) => theme.typography.fontSize.body};
`

const Description = styled.p`
  margin: 0 0 12px 0;
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  color: ${({ theme }) => theme.colors.text.secondary};
  line-height: 1.5;
`

export const DataSourceBanner: React.FC<DataSourceBannerProps> = ({
  egid,
  t,
  className,
}) => {
  return (
    <Banner className={className}>
      <Header>
        <Icon name="info" size="small" />
        {t('dataSourceBanner.title')}
      </Header>
      <Description>{t('dataSourceBanner.description')}</Description>
      {egid && (
        <RegBLLink
          egid={egid}
          label={t('dataSourceBanner.viewCompleteRecord')}
          t={t}
        />
      )}
    </Banner>
  )
}
